import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { PacienteDto } from '@shared/service-proxies/service-proxies';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-selecionar-dependente-dialog',
  templateUrl: './selecionar-dependente-dialog.component.html',
  styleUrls: ['./selecionar-dependente-dialog.component.scss']
})
export class SelecionarDependenteDialogComponent extends AppComponentBase {

  dependentes: PacienteDto[];
  dependenteSelecionado: string;;
  @Output() onSelect = new EventEmitter<any>();
  constructor(
    injector: Injector,
    public bsModalRef: BsModalRef,
  ) {
    super(injector);
  }

  selecionarDependente(){
    if(!this.dependenteSelecionado){
      abp.notify.warn("Selecione um dependente");
      return;
    }
    this.onSelect.emit(this.dependenteSelecionado);
    this.bsModalRef.hide();
  }
}
